import React from 'react';
import { UploadFile, UploadListType } from 'antd/lib/upload/interface';

export enum UploadCapacity {
  Bytes = 'b',
  KyloBytes = 'kb',
  MegaBytes = 'mb',
  GigaBytes = 'gb',
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface UploadItemProps<T = any> {
  file: UploadFile;
  fileList?: Array<UploadFile<T>>;
  originNode: React.ReactElement;
  listType?: UploadListType;
  isUploaded?: boolean;
  canDeleteUploaded?: boolean;
  showRefreshButton?: boolean;
  actions: {
    download: () => void;
    preview: () => void;
    remove: () => void;
  };
}
